<template>
  <div>
    <b-modal id="modalEditIpPools" ref="modalEditIpPools" :title="$t('IP pools')" hide-footer>
      <div v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id !== 0" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.name" aria-describedby="inputFeedbackName" :state="editItem.name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
              {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Address')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.address"/>
        </b-form-group>

        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditIpPools.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    editItem: null
  },
  methods: {
    save () {
      if (!this.editItem.name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      if (this.editItem.address) {
        if (this.editItem.address.includes(':')) {
          if (!this.validationIPv6()) {
            return
          }
          this.editItem.ip = this.editItem.address.split('/')[0]
          if (this.editItem.address.split('/')[1]) {
            this.editItem.mask_dec = Number(this.editItem.address.split('/')[1])
          } else {
            this.editItem.mask_dec = 128
          }
        } else {
          if (!this.validationIPv4()) {
            return
          }
          this.editItem.ip = this.editItem.address.split('/')[0]
          if (this.editItem.address.split('/')[1]) {
            this.editItem.mask_dec = Number(this.editItem.address.split('/')[1])
          } else {
            this.editItem.mask_dec = 32
          }
        }
      } else {
        this.editItem.ip = '127.0.0.1'
        this.editItem.mask_dec = 32
      }

      this.editItem.pool_id = this.editItem.id
      let response = this.editItem.pool_id !== 0
        ? this.$store.dispatch('Settings/UPDATE_IP_POOLS', this.editItem)
        : this.$store.dispatch('Settings/CREATE_IP_POOLS', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_IP_POOLS')
          this.$refs.modalEditIpPools.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    validationIPv4 () {
      let goodChars = '^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$'
      let valIP = this.editItem.address.split('/')[0]
      if (valIP.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    },
    validationIPv6 () {
      let goodChars = '(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))'
      let valIP = this.editItem.address.split('/')[0]
      if (valIP.match(goodChars)) {
        return true
      } else {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Incorrect IP format'), 'Error')
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/ipPools/editModal.vue